import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {IE3GoodsItemSummary} from "@portbase/bezoekschip-service-typescriptmodels";
import {ConsignmentUtils} from "../../../consignment.utils";

@Component({
    selector: 'app-consignment-goods-column',
    templateUrl: './consignment-goods-column.component.html',
    styleUrls: ['./consignment-goods-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConsignmentGoodsColumnComponent {
  @Input() term: string;
  @Input() goods: IE3GoodsItemSummary[];
  @Input() ellipsisCharacterCount: number = undefined;
  @Input() onClick: (good: IE3GoodsItemSummary) => void;

  goodsAsText = (goodsItem: IE3GoodsItemSummary) => ConsignmentUtils.goodsItemsAsText(goodsItem);
}
